import { render, staticRenderFns } from "./UpdateFranchise.vue?vue&type=template&id=92cfa136&scoped=true"
import script from "./UpdateFranchise.vue?vue&type=script&lang=js"
export * from "./UpdateFranchise.vue?vue&type=script&lang=js"
import style0 from "./UpdateFranchise.vue?vue&type=style&index=0&id=92cfa136&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92cfa136",
  null
  
)

export default component.exports